type integer = number
type int = number
type bool = boolean
type mac_t = string
type ip_t = string

export type Alignment_old = 'topLeft' | 'top' | 'topRight' | 'left' | 'center' | 'right' | 'bottomLeft' | 'bottom' | 'bottomRight'
export type RotateDegree_old = 180 | 270 | 0

export type Priority = 'strict' | 'high' | 'normal'
/** [RX only] Scaling the receiving video
 * TODO: 照理應該要有「偵測目前接上的電視所支援的最大解析度」這個選項？GoMax說理論上RX抓得到目前電視支援的最大解析度
 */
export type UpScaleMode = 'passThrough' | '720p60' | '1080p60' | '1080p50' | '2160p30' | '2160p25'
export type ExtenderResolution = '640x480@60' | '640x480@30' | '1280x720@60' | '1280x720@30' | '1680x1050@60' | '1680x1050@30' | '1920x1080@60' | '1920x1080@30'
export type OSDResolution= '640x480@60' | '1920x1080@60' | '3840x2160@30'
export type DeviceType = 'TX' | 'RX'
/** [TX only] normal means detected signal from source */
export type matrix_preset_index_t = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
export type extender_vendor_t = 'Aspeed' | 'Aptovision'
export type extender_series_t = 'HG' | 'HX'

/** DEPRECATED */
export type EdidLearningType = 'dynamic' | 'static'

export type rx_active_state_which_t = 'vw' | 'matrix' | ''

export enum OsdImageAlignment {
  topLeft = 1,
  top = 2,
  topRight = 3,
  left = 4,
  center = 5,
  right = 6,
  bottomLeft = 7,
  bottom = 8,
  bottomRight = 9,
}

/** (TX Only) */
export enum VideoOutMode {
  /** Enable Loop-out */
  allOn = 0,
  /** ITE only, don't use */
  _receiverOff = 1,
  /** Disable loop-out */
  loopOff = 2,
  /** ITE only, don't use */
  _allOff = 3
}

export enum RotateFlip {
  normal = 0,
  vert = 1,
  hori = 2,
  rotate180 = 3,
  rotate90_hori = 4,
  rotate90 = 5,
  rotate270 = 6,
  rotate270_hori = 7
}

export enum EdidMode {
  /** Default is 4K2K@60Hz HDR - 24bit 2D video & 2ch audio */
  default = 1,
  learningEDID = 2,
  _720P_LPCM = 3,
  _1080P_dolby = 4,
  _1080P_LPCM = 5,
  _3840x2160_dolby = 6,
  _3840x2160_LPCM = 7,
  _4096x2160_dolby = 8,
}
export enum UserPerm {
  Invalid = -1,
  ReadWrite = 1,
  ReadOnly = 2,
}

export interface ApiCurrentUser {
  /** An empty string means not logged-in yet. */
  account: string
  /** WS URL for this user. An empty string means not logged-in yet */
  wsid: string
}

export interface IUserLogin {
  account: string
  password: string
}

export interface IUserLoginResult_Legacy {
  /** HTTP code. <ex> 422 is Authentication Failed, 200 is OK */
  code: number
  message: string
}

export interface IUploadResult {  // DEPRECATED
  data: {
    success: boolean
    saved_as: string
  }
}

// ============================================================
// API (JsonRPC)
// ============================================================
export enum ApiReturnCode {
  FAILED = 0,
  SUCCESS = 1
}

export interface ApiDeviceMacParam {
  mac: string
}

export interface ApiGenericDeviceParam<T> extends ApiDeviceMacParam {
  value: T
}

export type ApiParamSetExtenderOsd = ApiGenericDeviceParam<integer>

export interface ApiParamDeleteOsd { id: number }
export interface ApiParamDeleteOsdImage { id: number }
export interface ApiParamDeletePreset { id: number }



export type ModelSnapshot = ApiGenericDeviceParam<string>  // DEPRECATED
export type ApiParamSetExtenderMute = ApiGenericDeviceParam<boolean>  // DEPRECATED
/** DEPRECATED  @interface value: group id of Extender */
export type ApiParamSetExtenderGroupId = ApiGenericDeviceParam<number>  // DEPRECATED
/** @interface mac the rx you want to switch client source  */
export type ApiParamSetExtenderClientSource = ApiGenericDeviceParam<ExtenderClientSource>  // DEPRECATED
export type ApiParamSetExtenderCEC = ApiGenericDeviceParam<boolean>  // DEPRECATED
// NOTE: Following is used by New API!

export interface ApiParamSetCurrentExtenderMapping {
  /** the preset index you want to set <ex> 3 */
  value: number
}

export type ApiParamSetDeviceName = ApiGenericDeviceParam<string>

export interface ApiParamMatrixJoin {
  txMac: string
  rxMac: string
}
export type ApiParamSetDisableAvOutput = ApiGenericDeviceParam<boolean>

export interface ApiVwBaseParam {
  id: integer
}

export interface ApiGenericVwParam<T> extends ApiVwBaseParam {
  value: T
}

export interface Preset {
  id: integer
  /** Name for this VideoWall, for human-readable. */
  name: string
  /** Notes for human */
  note: string
  /** Display number OSD on all RX screens <ex> false */
  vwList: ApiVw[]
  matrixList: Matrix[]
}

export interface Matrix {
  rxMac: string
  txMac: string
  rotateFlip: int
  osdid: int
}


export interface ApiUploadOsdImage {
  /** unique int (generated by UI automatically) */
  id: integer
  image: Blob // HTMLImageElement
}

export interface OsdImage {
  /** unique int (generated by UI automatically) */
  id: integer
  /** for human readable (specify by user) */
  name: string
  /** Used by UI, `/osd-images/${IMG_ID}?time=${TIME}` */
  fileName: string
  /** Mask the image according to the first pixel (left-top) of the image. Rendering mechanism is:
   *
   * 1. The background-color of the pixels with alpha channel (e.g. PNG) will be interpreted as black (#000000)
   * 2. According to the color of the first pixel to mask transparent.
   *    (e.g. if the first pixel #ff0000, all the pixels of #ff0000 in this image will be rendered as transparent)
   *
   * NOTE: Seems to have no tolerance so not recommended to use a JPEG with mask on.
   *   (e.g. for example, with lossy compression such as JPEG, the #ff0000 may be distorted to the color other than #ff0000)
   */
  mask: boolean
}

export interface OsdConfig {
  id: integer
  name: string
  isPicture: bool
  /** normalized value: [0~100] where 0 is invisible.
   * (actual value in extender: [1~31] where 1 is invisible)
   */
  opacity: int
  image: {
    alignment: OsdImageAlignment
    id: int
  }
  text: {
    center: bool
    shiftX: int
    shiftY: int
    content: string
    /** range is 1 ~ 200 */
    fontSize: int
    color: string
  }
}

export interface Extender {
  /** UNIX Epoch in second <ex> 223469 */
  connectionTime: number
  /** UNIX Epoch in second <ex> 223469 */
  uptime: number
  /** HDMI CEC standard <ex> true */
  cecFlag: boolean
  /** <ex> TX_02B62CBFDEAC */
  deviceName: string
  /** Serial Number */
  sn: string
  /** <ex> TX */
  deviceType: DeviceType
  /** Model name. e.g.
   * HG01P-R
   * HG01P-T
   */
  modelName: string
  /** If DHCP enabled. Currently this is immutable <ex> false */
  dhcpStatus: boolean
  /** <ex> 192.168.16.254 */
  gateway: string
  /**
   * 0 ~ 63: can be changed via the physical switchers on Extender.
   * 64 ~ 1023: can be changed via software.
   * If a TX and RX has same groupID, the output of the TX will be mapped to that RX <ex> 0
   */
  groupID: number
  /** HDCP (Don't confused with DHCP) enabled <ex> false
   * [On TX] Means if the source has DHCP
   * [On RX] Means if the connected TV supports DHCP
   * TODO: Can this know whether the mutual (TX & RX) HDCP version matched?
   */
  hdcpStatus: boolean
  /** Disable all video + audio. Appliable on RX & TX <ex> false */
  disableAVOutput: boolean
  /** <ex> 169.254.10.32 */
  ip: string
  /** If LED has been blinking (manipulate by user) <ex> false */
  ledBlinking: boolean
  /** <ex> 02:B6:2C:BF:DE:AC */
  mac: string
  /** <ex> 225.0.101.117 */
  multicastAddress: string
  /** <ex> 255.255.0.0 */
  netmask: string
  osdResolution: OSDResolution
  /* When an Extender plug on a Switch+SmartController, this value indicate the portNo which the Extender plugged on.
  * This valus is invalid on an individual SmartController.
  */
  // portNo: number
  // rxCurrentResoultion: string
  /** <ex> 0 */  // FIXME: WTF is this field & type
  rxScreenMode: number

  /** (RX only) The video scaling <ex> passThrough */
  upScaleMode: UpScaleMode
  /** <ex> Aspeed */
  vendor: extender_vendor_t
  txInfo: ExtenderTxInfo
  rxInfo: ExtenderRxInfo
}
/** RX-only query info */
export interface ExtenderRxInfo {
  screenMode: string
  tvDetected: boolean
  activeState: {
    which: rx_active_state_which_t
    vwid: int
    matrix: Matrix
  }
  /**
   * (VW only) The view port (window) of this RX on current TX.
   * If activeState.which === 'matrix', all value will be 0
   */
  vwTxWindow: {
    /** range: 0 - 10000 */
    x1: int
    /** range: 0 - 10000 */
    y1: int
    /** range: 0 - 10000 */
    x2: int
    /** range: 0 - 10000 */
    y2: int
  }
}
/** TX-only query info */
export interface ExtenderTxInfo {
  /** If a valid source is detected & inputting */
  sourceDetected: boolean
  /** (TX only) default | learningEDID. See @enum EdidMode <ex> 1 */
  edidMode: EdidMode
  /** (TX only) empty if edidMode = EdidMode.default, target extender macaddress if edidMode = EdidMode.learningFromEdid */
  learningEDIDFrom: mac_t | ''
  /** (TX only) <ex> static */
  learningType: EdidLearningType
}

export enum ExtenderClientSource {
  Ethernet = 1,
  HDMI = 2
}

export type VWName = string
export type ApiSetActiveVW = VWName[]

export interface ApiParamSetVwOsdConfig {
  enabled: boolean
  entry: {
    /** the rx macaddress in the current videowall config */
    mac: string
    /** the index of rx in this videowall config */
    value: number
  }
}

/** Represent a VideoWall. e.g. A Video Wall of 5 x 3, which contains 15 RXs.  */
export interface ApiVw {
  /** If this VW is enabled <ex> false */
  enabled: boolean
  /** VW is not compatible between various vendor */
  vendor: extender_vendor_t
  /** A unique number to identify this VideoWall. */
  id: number
  /** Name for this VideoWall, for human-readable. */
  name: string
  /** Display number (in fact it's implemented via OSD) on all RX screens.
   * This value is only used by API `VideoWall.Preview`. // TODO: docstring
   */
  displayIndex: boolean
  /** size of this VW */
  layout: ApiParamVWSize
  /** rx list. It's length must equal to {@link layout.columns} * {@link layout.rows} */
  rxList: ApiVwRx[]
  /** tx */
  txList: ApiVwTx[]
}

export interface ApiVwRx {
  mac: string
  /** Counted from 1 instead of 0.
   *  NOTE: This seems to be unnecessary? (the number which will showed as VW OSD)
   */
  displayIndex: integer
  bezel: ApiVwBezel
  /** 0 means disabled */
  osd: integer
}

/**
 *                3 columns
 *              0      1       2
 *           +------+------+------+
 *         0 |  1   |  2   |   3  |
 * 2 rows    +------+------+------+
 *         1 |  4   |  5   |   6  |
 *           +------+------+------+
 *
 * (Number in rect is displayIndex. In this mappings, 1 is the first, 6 is the last)
 */
export interface ApiVwTx {
  mac: string
  /** Nth column. Counted from 0 */
  column: integer
  /** Nth row. Counted from 0 */
  row: integer
  /** columns. Screen amount on x axis. */
  columns: integer
  /** rows. Screen amount on y axis. */
  rows: integer
  // NOTE: Does TX also requires bezel?
  rotateFlip: RotateFlip
}

/** TODO: any field having 0 means unset (?) */
export interface ApiVwBezel {
  /** Outer width */
  ow: number
  /** Outer height */
  oh: number
  /** Inner width */
  iw: number
  /** Inner height */
  ih: number
}

/**
 *               3 column
 *         +------+------+------+
 *         |  1   |  2   |   3  |
 *  2 row  +------+------+------+
 *         |  4   |  5   |   6  |
 *         +------+------+------+
 */
interface ApiParamVWSize {
  /** columns. Screen amount on x axis. */
  columns: integer
  /** rows. Screen amount on y axis. */
  rows: integer
}

export interface ApiParamOsdMapping {
  /** target rx macaddress */
  mac: string
  /** osd id, 0 means no OSD */
  value: number
}

interface AutoOIDStatus {
  rxName: boolean
  rxMacAddress: boolean
  groupName: boolean
  rxIpAddress: boolean
  groupID: boolean
  groupIpAddress: boolean
  accessQRCode: boolean
}

interface AutoOIDSetting {
  timeout: number
  backgroudColor: string
  /** <ex> #ff0000 */
  textColor: string
  /** Integer, 0 ~ 100 */
  transparency: number
}

interface ExtenderPos {
  alignment: Alignment_old
  offsetX: integer
  offsetY: integer
  height: integer
  width: integer
  rotate: RotateDegree_old
}

export interface ApiParamSetExtenderResolution {
    mac: string
    value: ExtenderResolution
}

export interface ModelSystemPlatform {
  /** <ex> pi */
  value: string
  /** <ex> */
  mac: string
}

export interface ModelSystemModel {
  /** <ex> SmartController */
  value: string
  /** <ex> */
  mac: string
}

export interface ModelLog {
  /** <ex> 1520844765000 */
  infoTime: number
  /** <ex> IP Switch */
  infoType: string
  /** <ex> HDMIoverIP */
  infoDeviceName: string
  /** <ex> auth (one of the 'auth', 'action', 'event', 'schedule') */
  infoTag: 'auth' | 'action' | 'event' | 'schedule'
  /**
   * log message content
   * <ex> admin login succes
   */
  infoMsg: string
}

export interface ModelTimeInfo {
  /** <ex> Asia/Taipei */
  timeZone: string
  /** <ex> 1520844765000 */
  unixTime: number
}

export interface LegacyModelVideoWallMapping {
  /** The mapping index starts from 1, leftTop */
  index: number
  /** The rx name mapped to this mapping */
  rxName: string
  /** The tx name mapped to this mapping */
  txName: string
  /** column amount of this mapping */
  column: number
  /** row amount of this mapping */
  row: number
  /**
   * 1. Please keep this same with the groupID of the TX whose name is txName.
   * 2. Need NOT to deal with the groupID of the RX whose name is rxName.
   *    (VideoWallMapping has higher priority than Matrix, so when a RX whose name is rxName existed in VideoWall setting,
   *     the RX will not be seemed as a RX in Matrix)
   */
  groupID: number
  adjustment: ModelVideoWallMappingAdjustment
  pos: ExtenderPos
}

interface ModelVideoWallMappingAdjustment {
  up: number
  down: number
  right: number
  left: number
  hScale: number
  vScale: number
}

export interface ApiParamExtenderEDID {
  mac: string
  edidMode: EdidMode
  /** empty if edidMode = 1, 3,4,5,6,7,8, target extender macaddress if edidMode = 2 */
  learningEDIDFrom: string
}

export interface SystemBasicInfo {
  name: string
  description: string
  location: string
  contact: string
  version: string
  model: string
  vendor: string
  /** seconds */
  uptime: integer
  /** seconds */
  date: integer
  serialNumber: string
  /** float, 0 ~ 100 */
  cpu: number
  /** MB */
  ramTotal: integer
  /** MB */
  ramUsage: integer
  /** MB */
  diskTotal: integer
  /** MB */
  diskUsage: integer
}

export interface SystemNetwork {
  mac: string
  ip: string
  ipv6: string
  netmask: string
  gateway: string
  dns: string
  dhcpClient: boolean
}
